import { fromGearCode, toDriveMode, fromBlinkerCode, toSelectorMode } from './DriveCommand';
import { Vehicle } from 'core/models/vehicle';
import { DriveMode, SelectorMode } from 'core/models/drive';

function adjustDriveMode(driveMode: DriveMode | undefined, selector: SelectorMode | undefined) {
    if (driveMode === DriveMode.Remote && selector === SelectorMode.Local) {
        // We deems FOA as a kind of Manual driving
        return DriveMode.Manual;
    }
    return driveMode;
}

function validateFields(fields: string[]) {
    switch (fields.length) {
        case 9:
            return ['', ...fields, '', ''];
        case 11:
            return [...fields, ''];
        case 12:
            return fields;
        default:
            return fields.length > 12 ? fields : undefined;
    }
}

function parseDriveStatusPayload(s: string): Partial<Vehicle.Status> {
    const fields = validateFields(s.split(','));
    if (!fields) return {};

    const [
        timestamp, targetSpeed, speed, angle, drivepedal, brakepedal, gear, lamp, light, drivemode, emergency, selector
    ] = fields;

    const selectorMode = selector !== '' ? toSelectorMode(parseInt(selector)) : undefined;

    return {
        timestamp: timestamp !== '' ? parseInt(timestamp) : undefined,
        targetSpeed: targetSpeed !== '' ? parseFloat(targetSpeed) : undefined,
        currentSpeed: speed !== '' ? parseFloat(speed) : undefined,
        steering: angle !== '' ? parseFloat(angle) : undefined,
        accel: drivepedal !== '' ? parseFloat(drivepedal) : undefined,
        brake: brakepedal !== '' ? parseFloat(brakepedal) : undefined,
        gear: gear !== '' ? fromGearCode(parseInt(gear)) : undefined,
        blinker: lamp !== '' ? fromBlinkerCode(parseInt(lamp)) : undefined,
        light,
        mode: adjustDriveMode(drivemode !== '' ? toDriveMode(parseInt(drivemode)) : undefined, selectorMode),
        emergency: emergency !== '' ? emergency === '1' : undefined,
        stateMessage: '',
    };
}

export type DriveStatus = {
    drive_status_message: {
        project_id: string;
        vehicle_id: string;
        payload: string;
    };
}

export function parseDriveStatus(driveStatusPayload: DriveStatus) {
    const { vehicle_id: vehicleId, project_id: projectId, payload } = driveStatusPayload.drive_status_message;

    const driveStatus = parseDriveStatusPayload(payload);
    return {
        vehicleId,
        projectId,
        statusDelta: driveStatus
    };
}
